import moment from 'moment'

const formattedDate = {
    methods: {
        getFormattedDate(date) {
            return date ? moment(date).format('DD.MM.YYYY HH:mm') : '';
        },
        getModelName(model, modelId, property) {
            const findingModel = this[model].find(model => model.id === modelId)
            if (findingModel) {
                return findingModel[property];
            }
            return ''
        }
    }
}
export default formattedDate
